// extracted by mini-css-extract-plugin
export default {"recent-searches-title":"CountryCardRecentSearches_recent-searches-title__KIe0r","recent-searches-country":"CountryCardRecentSearches_recent-searches-country__OCSQB"};